import Cookies from 'js-cookie'

$( document ).ready(function() {
    if(Cookies.get('comment-cookie') == 1) {
        $('.message-success').addClass('visible');
        setTimeout(() => $('.message-success').removeClass('visible'), 3000);
        Cookies.remove('comment-cookie');
    }
});